import { StatusValue } from '@/shared/enums';

export const statusStyles = (status: StatusValue): string => {
  switch (status) {
    case StatusValue.Submitted:
    case StatusValue.ToDo:
      return 'text-gray-300';
    case StatusValue.Analysis:
    case StatusValue.Quoted:
    case StatusValue.Blocked:
      return 'text-gray';
    case StatusValue.InProgress:
    case StatusValue.InQA:
    case StatusValue.Pending:
    case StatusValue.OnHold:
      return 'text-blue-500';
    case StatusValue.Done:
      return 'text-green';
    case StatusValue.Canceled:
    case StatusValue.Rejected:
      return 'text-red';
    default:
      return '';
  }
};
